<div id="kpi-wrapper" class="child-component pt-1" style="overflow-y: hidden !important;">
  <div class="section-details" style="overflow-x: scroll; height: calc(100% - 0px); overflow-y: hidden;">
    <as-split #splitRoot (dragStart)="onSplitDragStart()" (dragEnd)="onSplitDragEnd($event)" direction="horizontal" size="100">
          <as-split-area id="routelist" order="5" [size]="routeListRelativeSize" >
            <div class="d-flex " style="overflow-x: scroll; height: calc(100% - 15px); overflow-y: hidden;">
              <div class="route-list-container w-100 position-relative" #routeTable 
                [class.collapsed]="isGanttCollapsed">
                <div class="route-list-head px-2 py-1 d-flex align-items-center justify-content-between">
                  <div class="header-title d-none d-md-none d-lg-inline ellipsis-cell ">
                    <p>Route List</p>
                  </div>
                  <div class="d-flex align-items-center">
                  
                    <div class="position-relative me-2">
                      <input class="form-control form-control-sm ms-1 py-1" type="text" [(ngModel)]="searchText"
                        (input)="onSearchInput($event)" placeholder="Search" />
                  
                      <!-- Clear Button -->
                      <button *ngIf="searchText && searchText.length > 0" class="btn btn-sm btn-light ms-2 clear-icon"
                        (click)="clearSearchAndReset()" type="button">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                      @if(columnList.length && selectedKPIListValue) {
                        <app-column-visibility [ColumnListValue]="columnList" (handleColumnListChange)="handleColumnListChange($event)"
                          [selectedColumnListValue]="selectedKPIListValue">
                        </app-column-visibility>
                      }

                      <button
                        type="button"
                        class="pn-button pn-button-primary pn-icon-button mx-1"
                        (click)="exportExcel(kpiTable)"
                        pTooltip="Download in Excel"
                        tooltipPosition="left"
                        aria-label="Download in Excel">
                        <i class="pi pi-download"></i>
                      </button>
  
                      
                      @if( routePage == navigation.Dashboard) {
                        <app-create-route></app-create-route>
                      }

                      <!-- Route state filter icon + overlay -->
                      <img
                        [src]="hasPersistedRouteFilter ? 'assets/image/route_filter_active.svg' : 'assets/image/route_filter.svg'"
                        height="26" width="26"
                        alt="Route filter"
                        class="ms-1 pointer-cursor"
                        (click)="routesFilter.toggle($event)"
                        [pTooltip]="'Filter by Routes'"
                        tooltipPosition="left" />

                      <app-routes-filter
                        #routesFilter>
                      </app-routes-filter>
  
                  </div>
                </div>
                <p-table #kpiTable
                  [value]="routeList" dataKey="route_id" [rowTrackBy]="trackRouteById"
                  [rowHover]="true" [selectionMode]="isSelectionEnable ? 'multiple' : null"
                  [metaKeySelection]="false"
                  [selection]="isSelectionEnable ? dataRepositoryService.selectedRouteList : []"
                  (selectionChange)="isSelectionEnable && routeSelect($event)"
                  [scrollable]="true" [sortField]="currentSortField"
                  [sortOrder]="currentSortOrder"
                  scrollHeight="flex"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="rowHeight"
                  [customSort]="true"
                  (sortFunction)="onKPISort($event)"
                  [loading]="loading()"
                  [globalFilterFields]="['route_state','route_label','workshift_name','vehicle.reg_no']"
                  [style]="{'height': 'calc(100% - 31px)'}"
                  (onFilter) = "onGlobalFilter($event)"
                >
                    <ng-template pTemplate="loadingicon">
                      <i class="pi pi-spin pi-spinner fs-2 fw-bold"></i>
                    </ng-template>
                    <ng-template pTemplate="header" >
                      <tr>
                        <th scope="col" class="resetButtonCol" style="min-width: 60px  !important; display: table-cell;">
                          @if(isSelectionEnable) {
                            
                            <span *ngIf="dataRepositoryService.selectedRouteList.length>0" (click)="deselectAll()" class="anchor">Reset</span>

                          }
                        </th>
                        @if(isSelectionEnable) {
                        <th style="min-width: 90px !important; display:table-cell;">
                          Actions
                        </th>
                        }
                        @for (column of visibleColumns; track column.id) {
                        <th *ngIf="column.id !== 'loaded_planned' && column.id !== 'actions' && column.id !== 'kpi.items.moved_in_out'" [style.min-width]="column.width" [id]="column.id"
                          [pSortableColumn]="column.id">
                          {{column.label}}<p-sortIcon [field]="column.id" />
                        </th>
                        <th *ngIf="column.id === 'loaded_planned' || column.id === 'kpi.items.moved_in_out'" [style.min-width]="column.width" scope="col"
                          style="text-align: center !important;"> {{ column.label}}</th>
                      }
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-kpiData let-rowData="rowData" let-rowIndex="rowIndex">
                      <tr [pSelectableRow]="isSelectionEnable ? kpiData : null" [pSelectableRowIndex]="rowIndex">
                        <td style="min-width: 45px !important; display: table-cell;">
                          <p-tableCheckbox
                            *ngIf="isSelectionEnable"
                            [disabled]="taskInfoService.kpiSelectionDisabled"
                            [pSelectableRow]="kpiData"
                            [value]="kpiData"
                            ></p-tableCheckbox>
                        
                          <img [src]="kpiData.driver_information?.status | driverStatus"
                            [alt]="kpiData.driver_information?.status || 'Inactive'" [autoHide]="false" class="driver-status-svg" [pTooltip]="tooltipContent"
                            tooltipPosition="right" />
                          <ng-template #tooltipContent>
                            <div class="py-2 ps-2">
                              <p class="mb-1"> Status: <span [ngStyle]="{'color': kpiData.driver_information?.status === 'Active' ? '#2EBE39' : '#F04B5E'}"><b>{{kpiData.driver_information?.status}}</b></span></p>
                              <p class="mb-1"> Inactive Duration: <span><b>{{kpiData.driver_information?.idle_minutes != null ? (kpiData.driver_information.idle_minutes >= 60 ? (kpiData.driver_information.idle_minutes / 60 | number:'1.0-0') + ' hour' : kpiData.driver_information.idle_minutes + ' min') : 'NA'}}</b></span></p>
                              <p class="mb-1"> Timestamp: <span><b>{{kpiData.driver_information?.login_timestamp ? (kpiData.driver_information.login_timestamp | date : 'short') : 'NA'}}</b></span></p>
                              <p class="mb-1"> E-mail: <span><b>{{kpiData.driver_information?.user_name || 'NA'}}</b></span></p>
                            </div>
                          </ng-template>
                        </td>
                        @if(isSelectionEnable) {
                        <td style="min-width: 90px !important; display: table-cell; text-align: center;">
                          <span><img [src]="'assets/image/Optimization_icon_dp.svg'" height="14" width="14"
                              (click)="showRouteOptimization = !showRouteOptimization; routesDetails= kpiData; $event.stopPropagation()" class="pointer-cursor" />
                          </span>
                           <span class="align-middle" role="button" tabindex="0" (click)="openMenu($event, kpiData); $event.stopPropagation()"
                            (keydown.enter)="openMenu($event, kpiData)" (keydown.space)="openMenu($event, kpiData)"> <img height="14" width="14"
                              [src]="'assets/image/Kebab.svg'" /></span>
                          &nbsp;
                          <span class="align-middle" (click)="focusDriverMarkerOnMap(kpiData.route_id); $event.stopPropagation()"
                            (keydown.enter)="focusDriverMarkerOnMap(kpiData.route_id)"
                            *ngIf="kpiData | showVehicleIcon : selectedKPIRoutes()"><img height="14" width="14"
                              [src]="'assets/image/Live_location_dp_icon_selected.svg'" /></span>
                          </td>
                          }
                          @for (col of visibleColumns; track col.id) {
                            @switch (col.id) {
                              @case ('route_label') {
                                <td class="ellipsis-cell" style="min-width: 52px !important; display: table-cell;">
                                  @if(isSelectionEnable) {
                                    @let routeColour = dataRepositoryService.routesColour.get(kpiData.route_id);
                                    <div class="status-circle" [style.background-color]="routeColour"
                                      [style.visibility]="routeColour ? 'visible' : 'hidden'">
                                    </div>
                                  }
                                  <a href="javascript:void(0)" class="pointer-cursor anchor" (click)="openRouteDetails(kpiData)">
                                    {{ kpiData[col.id] }}
                                  </a>
                                </td>
                              }
                              @case ('route_state') {
                                <td style="min-width: 54px !important; display: table-cell;">
                                  <span [ngStyle]="kpiData.route_state | kpiRouteState">
                                    {{ kpiData.route_state }}</span>
                                  @if (kpiData.canCompleteRoute) {
                                    <button (click)="markRouteComplete(kpiData)" class="pi pi-pencil edit-icon"></button>
                                  }
                                </td>
                              }
                              @case ('kpi.stops.total') {
                                <td style="min-width: 50px !important; display: table-cell;"> {{ kpiData | kpiProgress : 'stops' }} / {{ kpiData.kpi.stops.total }}</td>
                              }
                              @case ('kpi.tasks.total') {
                                <td style="min-width: 50px !important; display: table-cell;"> {{ kpiData | kpiProgress : 'tasks'}} / {{ kpiData.kpi.tasks.total }}</td>
                              }
                              @case ('kpi.items.total') {
                                <td style="min-width: 50px !important; display: table-cell;">{{ kpiData | kpiProgress : 'items'}} / {{ kpiData.kpi.items.total }}</td>
                              }
                              @case ('loaded_planned') {
                                <td (click)="openRouteItemDetailsPopup(kpiData)" class="pointer-cursor"
                                  style="text-align: center !important;  min-width: 97px  !important; display: table-cell;">{{kpiData.kpi.items.total_loaded}} / {{kpiData.kpi.items.planned_at_sorting}}</td>
                              }
                              @case ('kpi.tasks.tasks_pr_hour') {
                                <td style="min-width: 60px !important; display: table-cell;">
                                  <span
                                    [style.color]="kpiData.kpi.tasks.tasks_pr_hour >= taskPerHourRefConstant ? 'green' : (kpiData.Taskhour === '' ? null : 'red')">
                                    {{ kpiData.kpi.tasks.tasks_pr_hour??'NA'}}</span>
                                </td>
                              }
                              @case ('kpi.tasks.task_workload_variance') {
                                <td>
                                  {{ kpiData.kpi.tasks.task_workload_variance > 0 ? "+"+kpiData.kpi.tasks.task_workload_variance :
                                  kpiData.kpi.tasks.task_workload_variance }}
                                </td>
                              }
                              @case ('vehicle.reg_no') {
                                <td style="min-width: 68px !important; display: table-cell;">
                                  <span [style.color]="kpiData.vehicle?.is_fossilfree ? 'green' : 'inherit'"
                                          [appLazyTooltip]="kpiData.vehicle?.is_fossilfree ? 'Fossil free vehicle' : '' ">
                                  {{ kpiData.vehicle?.reg_no }}</span>
                                </td>
                              }
                              @case ('kpi.items.moved_in_out') {
                                <td class="pointer-cursor"
                                  (keydown.enter)="openMovedInOutItemsDialog(kpiData)" (click)="openMovedInOutItemsDialog(kpiData);"
                                  style="text-align: center !important; display: table-cell;">
                                  {{ kpiData?.kpi?.items?.items_moved_in ?? 0 }} / {{ kpiData?.kpi?.items?.items_moved_out ?? 0 }}
                                </td>
                              }
                              @case ('kpi.items.planned_at_loading') {
                                <td class="pointer-cursor"
                                  (keydown.enter)="openPlannedAtLoadingItemsDialog(kpiData)" (click)="openPlannedAtLoadingItemsDialog(kpiData);"
                                  style="text-align: center !important; display: table-cell;">
                                  {{ kpiData?.kpi?.items?.planned_at_loading ?? 0 }}
                                </td>
                              }
                              @default {
                                <td class="wrapRowData" tooltipPosition="bottom" [appLazyTooltip]="kpiData[col.id]">
                                  {{ kpiData | kpiColumnValue : col.id }}
                                </td>
                              }
                            }
                          }
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr class="empty-message-row">
                        <td colspan="14">
                          <div class="text-center no-record-label">No Records found.</div>
                        </td>
                      </tr>
                    </ng-template>
                </p-table>
              </div>
            </div>
          </as-split-area>
          <as-split-area id="gantt" order="6" [visible]="ganttVisibleForCurrentRoute" [size]="ganttRelativeSize">
            <div class="timeline-stepper" aria-label="Adjust timeline window">
              <button
                type="button"
                class="timeline-arrow"
                (click)="decreaseTimeline()"
                [disabled]="!canDecrease || noRecords"
                aria-label="Zoom in timeline"
              >
                <i class="pi pi-chevron-left"></i>
              </button>
              <span class="timeline-label">{{ selectedTimelineLabel }}</span>
              <button
                type="button"
                class="timeline-arrow"
                (click)="increaseTimeline()"
                [disabled]="!canIncrease || noRecords"
                aria-label="Zoom out timeline"
              >
                <i class="pi pi-chevron-right"></i>
              </button>
            </div>
            <div
              [class.collapsed]="isGanttCollapsed"
                #ganttView class="gantt-view  w-100">
                <div #ganttHeader class="gantt-header"></div>
                <div 
                  #ganttChart
                  id="gantt-chart"
                  class="gantt-chart"
                ></div>
            </div>
          </as-split-area>
        </as-split>
        @if(isGanttToggleAvailable && isGanttCollapsed){
          <div id="left-btn" class="collapse-toogle" (click)="toggleTable()" [pTooltip]="'Collpase Route List'">
                <i class="pi pi-angle-left"></i>
            </div>
        }
        @if(isGanttToggleAvailable && !isGanttCollapsed){
          @if(isGanttDragged){
          <div id="right-btn" class="collapse-toogle" [style.left]="btnPosX" (click)="toggleTable()" [pTooltip]="'Expand Route List'">
              <i class="pi pi-angle-right"></i>
            </div>
          }
          @else{
            <div id="right-btn" class="collapse-toogle" [ngClass]="{
                          'collapsed-btn' : routePage == navigation.Dashboard, 
                          'collapsed-btn-gantt-page' : routePage == navigation.Gantt}" (click)="toggleTable()"
              [pTooltip]="'Expand Route List'">
              <i class="pi pi-angle-right"></i>
            </div>
            }
        }

    </div>
    <div class="kpi-summary">
      <div class="gantt-legend">
        <app-color-legends [colorlegends]="ganttLegends"></app-color-legends>
      </div>
    </div>
</div>

<!-- ROUTE OPTIMIZATION POPUP -->
<p-dialog [header]="'Route Optimization'" [(visible)]="showRouteOptimization" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-route-optimization *ngIf="showRouteOptimization" [routeDetails]="routesDetails"></app-route-optimization>
</p-dialog>

<p-dialog [header]="itemDetailsPopupInfo.title" [(visible)]="showItemDetails" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '90vw' }" [draggable]="false"
    [resizable]="false">
    <app-route-item-details *ngIf="showItemDetails" [taskid]="taskid" [itemColumnNames]="itemColumnNames" [routeDetails]="routesDetails" [itemState]="itemDetailsPopupInfo.itemState" >
    </app-route-item-details>
</p-dialog>

<!-- MERGE TASK starts -->
<p-menu #menu [model]="menuItems" [popup]="true" appendTo="body">
  <ng-template #item let-item>
    <a [class.p-disabled]="item.disabled" (click)="!item.disabled && onMenuItemClick($event, item)">{{ item.label }}</a>
  </ng-template>
</p-menu>

<p-dialog [(visible)]="showMergeTaskDialog" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '60vw' }"
  [style]="{ width: '55vw'}" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="pn-dialog-header">
      <p class="pn-heading-title mb-0">Merge Task</p>
      <p class="pn-heading-subtitle mb-0">Combine multiple tasks into a single optimised delivery task</p>
    </div>
  </ng-template>
  <app-merge-task-dialog #mergeTaskDialogRef *ngIf="showMergeTaskDialog" [routeDetails]="selectedRow"
    (closeDialog)="showMergeTaskDialog = false"></app-merge-task-dialog>
</p-dialog>

<p-dialog header="Moved in/out Items" [(visible)]="displayMovedInTasksDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-moved-in-out-dialog *ngIf="displayMovedInTasksDialog" [routeDetails]="routesDetails"></app-moved-in-out-dialog>
</p-dialog>

<p-dialog header="Items Planned after Load Start" [(visible)]="displayPlannedAtLoadingDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-planned-at-loading-dialog *ngIf="displayPlannedAtLoadingDialog" [routeDetails]="routesDetails"></app-planned-at-loading-dialog>
</p-dialog>